<template>
    <div class="security-visual"
         :class="{'is-polling': polling, 'is-unlocking': isUnlocking, 'is-unlocked': isUnlocked, 'is-denied': isDenied}">
        <!-- Lock icon -->
        <svg class="lock" viewBox="0 0 64 64" aria-hidden="true">
            <path class="shackle" d="M20 26v-6a12 12 0 1 1 24 0v4" fill="none"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
            <rect class="body" x="14" y="26" width="36" height="28" rx="6" ry="6"
                  fill="currentColor"/>
            <circle class="keyhole" cx="32" cy="40" r="3.5" fill="#fff"/>
        </svg>
        <!-- Spinner ring for polling state -->
        <svg class="spinner" viewBox="0 0 64 64" aria-hidden="true">
            <circle class="spinner-track" cx="32" cy="32" r="28" fill="none"
                    stroke="currentColor" stroke-width="4" opacity="0.2"/>
            <circle class="spinner-arc" cx="32" cy="32" r="28" fill="none"
                    stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
        </svg>
        <!-- Success check -->
        <svg class="check" viewBox="0 0 64 64" aria-hidden="true">
            <circle class="ring" cx="32" cy="32" r="28" fill="none" stroke="currentColor"
                    stroke-width="4"/>
            <path class="mark" d="M18 34l9 9 19-20" fill="none" stroke="currentColor"
                  stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        polling: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isUnlocking: false,
            isUnlocked: false,
            isDenied: false,
            denyTimeout: null,
        };
    },

    computed: {
        /**
         * Whether the visual is in a success state (unlocking or unlocked)
         */
        isSuccess() {
            return this.isUnlocking || this.isUnlocked;
        },
    },

    methods: {
        /**
         * Trigger the unlock → check mark animation sequence
         */
        triggerUnlock() {
            this.isUnlocking = true;

            setTimeout(() => {
                this.isUnlocking = false;
                this.isUnlocked = true;
            }, 400);
        },

        /**
         * Trigger the deny/error shake animation on the lock
         */
        triggerDeny() {
            if (this.denyTimeout) {
                clearTimeout(this.denyTimeout);
            }

            this.isDenied = true;

            this.denyTimeout = setTimeout(() => {
                this.isDenied = false;
            }, 500);
        },

        /**
         * Reset the visual to its default state
         */
        reset() {
            this.isUnlocking = false;
            this.isUnlocked = false;
            this.isDenied = false;

            if (this.denyTimeout) {
                clearTimeout(this.denyTimeout);
            }
        },
    },

    beforeDestroy() {
        if (this.denyTimeout) {
            clearTimeout(this.denyTimeout);
        }
    },
};
</script>
